import moment from 'moment-timezone';
import api from '../services/api';

/**
 * Copia o arquivo escolhido para a memória.
 *
 * No celular, o arquivo vindo da galeria/câmera é uma referência do sistema de
 * arquivos que pode ficar indisponível entre a escolha e o envio (app em segundo
 * plano, arquivo movido pela galeria). Quando isso acontece o navegador não
 * consegue montar o corpo da requisição e o upload falha antes de chegar na API,
 * aparecendo como "Network Error".
 *
 * Em caso de falha na leitura, devolve o arquivo original — é melhor tentar o
 * envio do que impedir o cadastro.
 */
export async function copiaArquivoEmMemoria(arquivo) {
    if (!arquivo) {
        return null;
    }

    try {
        const buffer = await arquivo.arrayBuffer();

        return new File([buffer], arquivo.name, {
            type: arquivo.type,
            lastModified: arquivo.lastModified,
        });
    } catch (e) {
        console.error('Não foi possível copiar o arquivo para a memória:', e);
        return arquivo;
    }
}

/**
 * Anexa o relatório de telemetria também aos arquivos do agendamento.
 *
 * O relatório é gravado no relato do atendimento (é de lá que os indicadores são
 * lidos), então sem isto ele não aparece em "Arquivos do Agendamento" — que é onde
 * a operação procura o que foi enviado.
 *
 * Falha aqui não interrompe nada: o relatório já está salvo no relato.
 */
export async function anexaTelemetriaAoAgendamento(arquivo, agendamentoId) {
    if (!arquivo || !agendamentoId) {
        return;
    }

    try {
        const formData = new FormData();

        formData.append('arquivo', arquivo);
        formData.append('nome', `Telemetria - ${arquivo.name}`);
        formData.append('agendamento_id', agendamentoId);
        formData.append('data', moment().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss'));
        formData.append('tipo', 'monitoramento');
        formData.append('pessoa_id', 1);
        formData.append('aprovado', 'true');  // não entra no fluxo de aprovação de laudo

        await api.post('/agendamentos/arquivos/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    } catch (e) {
        console.error('Não foi possível anexar a telemetria aos arquivos do agendamento:', e);
    }
}
